import { authenticationService } from './authentication';
import { MarketingAttributes } from '../interfaces/MarketingAttributesInterface';

class MarketingDataAttributesSetter {
    public async updateUserAttributes(): Promise<void> {
        const marketingData = this.getMarketingDataFromLocalStorage();
        if (Object.keys(marketingData).length > 0) {
            await authenticationService.updateAttributes(marketingData);
        }

        this.removeMarketingDataFromLocalStorage();
    }

    private getMarketingDataFromLocalStorage(): Partial<MarketingAttributes> {
        const marketingQueryParams = localStorage.getItem('marketingData');
        try {
            return JSON.parse(marketingQueryParams ?? '{}');
        } catch {
            return {};
        }
    }

    private removeMarketingDataFromLocalStorage(): void {
        localStorage.removeItem('marketingData');
    }
}

export const updateMarketingDataAttributesService =
    new MarketingDataAttributesSetter();



// WEBPACK FOOTER //
// ./src/webportal/services/MarketingDataAttributesSetter.ts